module.exports = __webpack_public_path__ + "static/media/close_project.6916a7db.svg";